import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {PASearch} from "../PA.Core/PASearch";
import {ModelFunctionBO} from "./ModelFunctionBO";


export class ModelFunctionBOValidations {


    static ValidateFields(aBO: ModelFunctionBO): Promise<void> {
        let bmodelIdExists = false
        let queryparm: any = {}
        let modelfunctionid = aBO.drWB_ModelFunction.cif.MODEL_FUNCTION_ID;
        let periodOffset = aBO.drWB_ModelFunction.cif.PERIOD_OFFSET_MAX
        queryparm.MODEL_FUNCTION_ID = modelfunctionid
        return new Promise((resolve, reject) => {

            let coeffCount = aBO.drWB_ModelFunction.cif.COEFFICIENT_COUNT
            if (_.toNumber(coeffCount) > 3) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'coeffCountGreaterThan2',
                        type: MessageType.Error,
                        title: `Coefficient Count cannot be greater than 3`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            }
            if(aBO.drWB_ModelFunction.cif.MODEL_FUNCTION_TYPE === 'Decay') {
                if(_.toNumber(_.lt(periodOffset, 1))) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'periodOffset',
                            type: MessageType.Error,
                            title: `Period Offset cannot be less than 1`,
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                }
            }
            let constantCount = aBO.drWB_ModelFunction.cif.CONSTANT_COUNT
            if (_.toNumber(constantCount) > 3) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'constantCountGreaterThan3',
                        type: MessageType.Error,
                        title: `Constant Count cannot be greater than 3`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            }
            if (_.toNumber(constantCount) < 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'constantCountNegative',
                        type: MessageType.Error,
                        title: `Constant Count cannot be less than 0`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            }
            resolve();
        })

    }
}
